export type ISODateString = string
export type ISODateTimeString = string
export type WeekDays = 0 | 1 | 2 | 3 | 4 | 5 | 6

/**
 * It is a lot more efficient for us when querying events
 * within a range if there is always an ending date even
 * when recurrence options say this should repeat forever
 */
export const RECURRENCE_FOREVER_DATE = 33333333333333

export interface IntervalDates {
  start: Date
  end: Date
}

export interface IntervalISOString {
  start: ISODateTimeString
  end: ISODateTimeString
}

export interface IntervalInTimeZone {
  timeZone: string
  start: Date
  end: Date
}

export interface RecurrenceException {
  start: Date
  duration: number
}
